<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">CountryLists</span>
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/countrylists/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control"
                                v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod"
                                @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
        <CustomList v-else ref="loadCustom"></CustomList>
    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/CountryLists/MenuList.vue";
    import lang from "@/views/modules/CountryLists/language/en";
    import GenericList from "@/components/layout/shared/generic/ListView.vue";
    import CustomList from "@/views/modules/CountryLists/ListView.vue";
    import CustomSearch from "@/views/modules/CountryLists/SearchView.vue";

    export default {
        name: "new-categorys",
        components: {
            breadcrumbs,
            GenericList,
            CustomList,
            CustomSearch
        },
        data() {
            return {
                generic: true,
                isActive: false,
                metaList: [
                    {
                        label: lang.LBL_COUNTRY_NAME,
                        link: true,
                        linkOtherModule:false,
                        moduleName: 'CountryLists',
                        routePath: 'countrylists'
                    },
                    {
                        label: lang.LBL_ISD_CODE,
                        link: false,
                        linkOtherModule:false,
                    },
                    {
                        label: lang.LBL_STATUS,
                        link: false,
                        linkOtherModule:false,
                    },
                   
                ],
                columns: ['name', 'isd_code', 'status'],
            }
        },
        mounted() {
            this.childMethod();
            
        },
        methods: {
            childMethod() {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns);
                }
            },
            openAction() {
                this.isActive = !this.isActive;
            },
        }
    }
</script>